import ProceedWithoutAuthBtn from './ProceedWithoutAuthBtn'

export default ProceedWithoutAuthBtn
